// src/ProtectedRoute.js
// ============================================================
// ScholarSync AI — Protected Route Wrapper
// ============================================================
// Wraps routes that require authentication.
// Shows loading spinner while token is being validated,
// redirects to /login if no valid session.
// Passes current location so login/register can redirect back.
// ============================================================
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  // Still validating token — show loading state
  if (loading) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#F3F4F6',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      }}>
        <p style={{ color: '#6B7280', fontSize: '14px' }}>Loading…</p>
      </div>
    );
  }

  // No valid session — redirect to login, preserving intended destination
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}